import { useQuery } from "@tanstack/react-query";
import { getContactPersonById, getContactPersonNotes, getContactPersonProjects } from "../../api/contactPersons";
import { getActivitiesByContactPerson } from "../../api/activities";

const useContactPersonDetails = (contactPersonId: number) => {
  const detailsQuery = useQuery({
    queryKey: ["contactPerson", contactPersonId],
    queryFn: () => getContactPersonById(contactPersonId),
    enabled: !!contactPersonId,
  });

  const notesQuery = useQuery({
    queryKey: ["contactPersonNotes", contactPersonId],
    queryFn: () => getContactPersonNotes(contactPersonId),
    enabled: !!contactPersonId,
  });

  const projectsQuery = useQuery({
    queryKey: ["contactPersonProjects", contactPersonId],
    queryFn: () => getContactPersonProjects(contactPersonId),
    enabled: !!contactPersonId,
  });

  const activitiesQuery = useQuery({
    queryKey: ["contactPersonActivities", contactPersonId],
    queryFn: () => getActivitiesByContactPerson(contactPersonId),
    enabled: !!contactPersonId,
  });

  return {
    contactPersonDetails: detailsQuery.data?.data,
    notes: notesQuery.data?.data ?? [],
    projects: projectsQuery.data?.data ?? [],
    activities: activitiesQuery.data?.data ?? [],
    isDetailsLoading: detailsQuery.isLoading,
    isActivitiesLoading: activitiesQuery.isLoading,
    isNotesLoading: notesQuery.isLoading,
    isProjectsLoading: projectsQuery.isLoading,
    detailsError: detailsQuery.error,
    activitiesError: activitiesQuery.error,
    notesError: notesQuery.error,
    projectsError: projectsQuery.error,
  };
};

export default useContactPersonDetails;
